import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function ReasonOfDecline({
  data,
  setshowReasonPage,
  reqCourses,
  setReqCourses,
}) {
  let api = useAxiosPrivate();

  useEffect(() => {
    window.scrollTo(0, 0);
    disableScroll();

    return () => {
      enableScroll();
    };
  }, []);

  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  // call this to Disable
  function disableScroll() {
    window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
    window.addEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener("touchmove", preventDefault, wheelOpt);
    window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  async function RemoveFromReject(bID, courseCode, courseDept, courseOwner) {
    let resp =
      await api.get(`courseallocation/removeRejectedRequests?batch=${bID}
        &courseCode=${courseCode}
        &requester=${courseDept}
        &requestedTo=${courseOwner}`);

    if (resp.data.msg == true) {
      setshowReasonPage(false);
      removefromrejectalignwithdatabase(courseCode);
    }
  }
  function removefromrejectalignwithdatabase(courseCode) {
    let arr = [];
    reqCourses.forEach((req) => {
      if (req.course_code == courseCode) {
        req.declined = false;
        req.requested = true;
        req.requestStatus = "Pending...";
      }
      arr.push(req);
    });

    setReqCourses(arr);
  }

  function selfAssignalignwithdatabase() {
    let aligneddatawithdatabase = reqCourses.filter(
      (req) => req.course_code !== data.courseCode
    );
    setReqCourses(aligneddatawithdatabase);
  }

  async function addToSelfAssign() {
    let resp = await api.post(`courseallocation/selfassignrequestedcourse`, {
      courseCode: data.courseCode,
      curriculumId: data.curriculum,
    });

    if (resp.data.msg == true) {
      setshowReasonPage(false);
      selfAssignalignwithdatabase();
    }
  }

  return (
    <div className="reasonContainer">
      <div className="reasonWrapper">
        <p style={{ textAlign: "right" }}>
          <CloseIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setshowReasonPage(false);
            }}
          />
        </p>

        <h2 style={{ textAlign: "center", color: " #cd853f" }}>
          Reason for Decline
        </h2>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "10px 10px",
          }}
        >
          <p
            style={{
              textAlign: "left",
              overflowWrap: "break-word",
              width: "70%",
              border: "1px solid lightgray",
              padding: "10px 10px",
            }}
          >
            {data.courseDeclineReason}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            sx={{ marginLeft: "15px" }}
            onClick={() => {
              addToSelfAssign();
            }}
          >
            Self Assign
          </Button>

          <Button
            variant="outlined"
            sx={{ marginLeft: "15px" }}
            onClick={() => {
              RemoveFromReject(
                data.batch,
                data.courseCode,
                data.courseDept,
                data.courseOwner
              );
            }}
          >
            Re-Request
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ReasonOfDecline;
